var currencies = {

    async usd_brl(){

        const ref = window.firebase.database().ref("/usd_brl");//.orderByChild('createdAt').startAt(1602471600000).endAt(1602471600001);
        var v = await ref.once('value', snapshot => {
            var values = snapshot.val()
            console.log(values)
             return values
        })
         console.log(  JSON.stringify(v));
         console.log(typeof(v));
        var v= JSON.parse(JSON.stringify(v));
        return v.value
    }
};

export default currencies;